import { render, staticRenderFns } from "./ReissuePassword.vue?vue&type=template&id=a050e118&scoped=true"
import script from "./ReissuePassword.vue?vue&type=script&lang=js"
export * from "./ReissuePassword.vue?vue&type=script&lang=js"
import style0 from "./ReissuePassword.vue?vue&type=style&index=0&id=a050e118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a050e118",
  null
  
)

export default component.exports